import React, { useState, useEffect, useCallback } from "react";
import "./multimediaItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPenToSquare,
    faCopy,
    faExternalLinkAlt,
    faImages,
    faCoins,
    faDeleteLeft
} from "@fortawesome/free-solid-svg-icons";
import createDOMPurify from "dompurify";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextareaRich from "../../html/textareaRich/textareaRich";
import Modal from "../../commons/modal/modal";
import MultimediaForm from "./multimedia-form";
import { Link } from "react-router-dom";
import { MultimediaService, MultimediaPackService } from "../multimedia.service";
import { isAudio, isImage, isVideo } from '../../../utils/ValidationTypeFile'


export default function MultimediaItem(props) {
    const { data, setDataList, listaA } = props;
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [valueEdit, setValueEdit] = useState({});
    const [dataMultimedia, setDataMultimedia] = useState({});

    useEffect(() => {
        console.log('ITEM item  ->///////////////', data)
        console.log('ITEM item  ->///////////////2222', listaA)
        setDataMultimedia(data)
    }, [])

    const statusValidationLabels = {
        A: 'Aprobado',
        P: 'Pendiente',
        R: 'Rechazado',
        M: 'Modificar',
    };

    // function isVideo(filename) {
    //     if (!filename) {
    //         return false; // Si filename no está definido o es null, asumimos que no es un video
    //     }
    //     const videoExtensions = ["mp4", "webm", "ogg"]; // Puedes agregar más extensiones de video si lo necesitas
    //     const extension = filename.split(".").pop().toLowerCase();
    //     return videoExtensions.includes(extension);
    // }



    return (
        <div className="item-multimedia-container">
            <MultimediaForm
                isEdit={true}
                value={valueEdit}
                showModal={showModalEdit}
                setShowModal={setShowModalEdit}
                onChangeModal={
                    (item) => {
                        console.log('7777777777')
                        console.log(item)

                        setDataMultimedia(item);

                    }
                }
            />
            <div className="item-multimedia-state">
                <div className={`item-status-multimedia${dataMultimedia.status_validation}`}  >
                    {statusValidationLabels[dataMultimedia.status_validation]}
                </div>
                <div>
                    {
                        (dataMultimedia.status_validation !== 'A') &&
                        <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="icon-pack-action"
                            onClick={() => {
                                setValueEdit(dataMultimedia);
                                setShowModalEdit(true);
                            }}
                        />
                    }
                    {
                        (dataMultimedia.status_validation !== 'A') &&
                        <FontAwesomeIcon
                            icon={faDeleteLeft}
                            className="icon-pack-action"
                            onClick={async () => {
                                if (window.confirm('¿Estás seguro de que quieres eliminar este ítem?')) {

                                    if (await MultimediaService("DEL", {}, null, null, dataMultimedia.id)) {
                                        //console.log('dataList ', dataList) 
                                        console.log('id : ', dataMultimedia.id)
                                        //const tempDataList = dataList.filter(item => item.id != dataMultimedia.id);

                                        setDataList(tempDataList => {
                                            console.log('TEMPO --- ', tempDataList)
                                            const dataRe = tempDataList.filter(item => item.id != dataMultimedia.id);
                                            console.log('dataRe --- ', dataRe)
                                            return dataRe
                                        })
                                        //console.log('tempDataList', tempDataList) 



                                    }


                                }
                            }}
                        />
                    }
                </div>
            </div>
            <div className="item-mutimedia-item">
                {/* Puedes agregar más fuentes de video para formatos diferentes aquí */}
                <div>
                    {isVideo(dataMultimedia.preview_content) && (
                        <video controls>
                            <source src={dataMultimedia.preview_content} type="video/mp4" />
                            Tu navegador no admite el elemento de video.
                        </video>
                    )}

                    {isImage(dataMultimedia.preview_content) && (
                        <img src={dataMultimedia.preview_content} />
                    )}
                    {isAudio(dataMultimedia.preview_content) && (
                        <audio controls>
                            <source src={dataMultimedia.preview_content} type="audio/mpeg" />
                            Tu navegador no admite la reproducción de audio.
                        </audio>
                    )}

                    {isVideo(dataMultimedia.preview_content) && <span>Video (Gratuito)</span>}
                    {isImage(dataMultimedia.preview_content) && <span>Imagen Gratuito</span>}
                    {isAudio(dataMultimedia.preview_content) && <span>Audio Gratuito</span>}
                </div>



                
                <div>
                    {isVideo(dataMultimedia.file) && (
                        <video controls>
                            <source src={dataMultimedia.file} type="video/mp4" />
                            Tu navegador no admite el elemento de video.
                        </video>
                    )}


                    {isImage(dataMultimedia.file) && (
                        <img src={dataMultimedia.file} />
                    )}

                    {isAudio(dataMultimedia.file) && (
                        <audio controls>
                            <source src={dataMultimedia.file} type="audio/mpeg" />
                            Tu navegador no admite la reproducción de audio.
                        </audio>
                    )}
                    {isVideo(dataMultimedia.file) && <span>Video (Pago)</span>}
                    {isImage(dataMultimedia.file) && <span>Imagen (Pago)</span>}
                    {isAudio(dataMultimedia.file) && <span>Audio (Pago)</span>}
                </div>
            </div>
        </div>
    );
}
